import React from 'react';
import {
  Checkbox as MuiCheckbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import GlassmorphismDesignSystem from '../theme/GlassmorphismDesignSystem';

const Checkbox = ({
  label,
  value,
  onChange,
  error,
  help,
  required,
  onBlur,
  name,
  ...props
}) => {
  const theme = useTheme();
  const isDarkmode = theme.palette.mode === 'dark';

  const handleChange = (event) => {
    if (onChange) {
      onChange(
        {
          target: {
            name: name,
            value: event.target.checked,
            checked: event.target.checked,
          },
        },
        'boolean'
      );
    }
    if (onBlur) {
      onBlur(
        {
          target: {
            name: name,
            value: event.target.checked,
            checked: event.target.checked,
          },
        },
        'boolean'
      );
    }
  };

  return (
    <FormControl
      required={required}
      {...props}
      sx={{
        background:
          GlassmorphismDesignSystem.patterns.interactive.background(theme),
        backdropFilter:
          GlassmorphismDesignSystem.patterns.interactive.backdropFilter,
        border: GlassmorphismDesignSystem.patterns.interactive.border(theme),
        boxShadow:
          GlassmorphismDesignSystem.patterns.interactive.boxShadow(theme),
        borderRadius: '8px',
        width: '100%',
        height: 'auto',
        '& .MuiFormLabel-asterisk': { color: theme.palette.text.secondary },
      }}
    >
      <FormControlLabel
        sx={{ alignItems: 'flex-start', '& .MuiFormControlLabel-label': { fontSize: '12px', marginTop: '8px', marginBottom: '8px', marginLeft: '-5px' } }}
        control={
          <MuiCheckbox
            checked={!!value}
            onChange={handleChange}
            name={name}
            sx={{
              fontSize: '11px',
              padding: '8px 16px',
            }}
          />
        }
        label={label}
      />
      {help && <FormHelperText>{help}</FormHelperText>}
    </FormControl>
  );
};

export default Checkbox;
